import React from "react";
import Script from "next/script";

import styles from "./ad.module.css";

const BrandMetrics: React.FunctionComponent = () => (
    <>
        <div
            id="brandmetrics-survey"
            className={styles.brandmetricsContainer}
        />
        <Script
            dangerouslySetInnerHTML={{
                __html: ` 
            window._brandmetrics = window._brandmetrics || [];
            window._brandmetrics.push({ cmd: "_loadsurvey" });`,
            }}
            id="brand-metrics"
            strategy="afterInteractive"
        />
    </>
);

export default BrandMetrics;
